import { validateEmail } from "../../../../utilities/generalUtilities";

// Mirrors ParticipantEmailCc.MaxAddresses in enterprise-session-api — the API rejects more.
export const MAX_CC_ADDRESSES = 20;

// The API takes CC as an array with one plain address per element and rejects delimited
// strings, so anything typed or pasted as "a@x.com, b@x.com; c@x.com" is split here first.
// Trims, drops blanks, and de-duplicates case-insensitively (first spelling wins).
export const parseCcAddresses = (entries: string[]): string[] => {
    const seen = new Set<string>();
    const result: string[] = [];
    entries
        .flatMap((entry) => entry.split(/[\s,;]+/))
        .filter((address) => address !== "")
        .forEach((address) => {
            const key = address.toLowerCase();
            if (!seen.has(key)) {
                seen.add(key);
                result.push(address);
            }
        });
    return result;
};

export const isValidCcAddress = (address: string): boolean => validateEmail(address);
